import { Mail, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import LogoIcon from './LogoIcon';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="relative z-10 bg-background/95 backdrop-blur-md border-t border-newsletter-primary/10 mt-16">
      <div className="container mx-auto px-4 py-6">
        {/* Policy Links */}
        <div className="flex flex-wrap justify-center gap-4 text-sm pb-4 border-b border-newsletter-primary/5">
          <Link 
            to="/cookie-policy"
            className="text-muted-foreground hover:text-newsletter-primary transition-colors duration-200"
          >
            {t('footer.cookiePolicy')}
          </Link>
          <span className="text-muted-foreground/50">•</span>
          <Link 
            to="/privacy-policy"
            className="text-muted-foreground hover:text-newsletter-primary transition-colors duration-200"
          >
            {t('footer.privacyPolicy')}
          </Link>
          <span className="text-muted-foreground/50">•</span>
          <Link 
            to="/terms-of-use"
            className="text-muted-foreground hover:text-newsletter-primary transition-colors duration-200"
          >
            {t('footer.termsOfUse')}
          </Link>
        </div>
        
        {/* Main footer content */}
        <div className="flex flex-col items-center gap-6">
          <div id="footer-contacts" className="flex items-center gap-4 text-sm">
            <a 
              href="mailto:contact@newsforyou.ai"
              className="flex items-center gap-2 text-muted-foreground hover:text-newsletter-primary transition-colors duration-200"
            >
              <Mail className="w-4 h-4" />
              contact@newsforyou.ai
            </a>
            <a 
              href="https://instagram.com/newsforyou.ai" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-muted-foreground hover:text-newsletter-primary transition-colors duration-200"
            >
              <Instagram className="w-4 h-4" />
              @newsforyou.ai
            </a>
          </div>
          
          <p className="text-sm text-muted-foreground text-center">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};